<template>
  <div id="other_r">
    <top></top>
    <div class="main">
      <div class="content">
        <img class="other_r_icon" :src="status.icon" alt="" />
        <div class="other_r_status" :class="status.type">
          {{
            examineStatus == 9
              ? status.text + "\n" + reject_reason
              : status.text
          }}
        </div>
        <div class="other_r_button">
          <div class="declare_borderButton" @click="back">返回</div>
          <div class="declare_fillButton" @click="re_edit">重新编辑</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../../components/top.vue";
export default {
  name: "activityReview",
  components: { top },
  created() {
    this.examineStatus = this.$route.query.examine_status;
    this.reject_reason = this.$route.query.reject_reason;
    this.statusGroup.forEach((item) => {
      if (item.status_code == this.examineStatus) {
        this.status = item;
      }
    });
  },
  data() {
    return {
      statusGroup: [
        {
          type: "resolve",
          status_code: 2,
          icon: require("../../assets/icon_status2.png"),
          text: "您的活动已通过审核！",
        },
        {
          type: "reject",
          status_code: 9,
          icon: require("../../assets/icon_status3.png"),
          text: "您的活动审核被驳回，驳回原因:",
        },
        {
          type: "pending",
          status_code: 1,
          icon: require("../../assets/icon_status1.png"),
          text: "您的活动正在审核中，请耐心等待",
        },
      ],
      status: {},
      reject_reason: "",
      examineStatus: "",
    };
  },
  methods: {
    re_edit() {
      this.$router.push({
        path: "/otherDeclaration",
      });
    },
    back() {
      this.$router.push({
        path: "/home",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.other_r_icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 200px auto 0;
  display: block;
}
.other_r_status {
  width: 865px;
  padding: 32px 20px;
  box-sizing: border-box;
  border-radius: 18px;
  line-height: 28px;
  font-size: 14px;
  text-align: center;
  margin: 20px auto 0;
  white-space: pre-line;
}
.resolve {
  background: rgba(82, 196, 26, 0.1);
  color: #52c41a;
}
.reject {
  background: rgba(255, 77, 79, 0.1);
  color: #ff0000;
}
.pending {
  background: rgba(250, 173, 20, 0.1);
  color: #faad14;
}
.other_r_button {
  display: flex;
  width: 272px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100px;
  justify-content: space-between;
  align-items: center;
  > div:first-child {
    margin-right: 20px;
  }
}

@media screen and (max-width: 1660px) {
  .other_r_icon {
    margin: 100px auto 0;
  }
}
</style>
